<script lang="ts">
	import { tooltip } from "tooltip"

	interface Props {
		isEnabled: boolean
		disabled?: boolean
		info?: string
		onUpdate?: (newVal: boolean) => void
	}

	let {
		isEnabled,
		disabled = false,
		info = undefined,
		onUpdate = undefined,
	}: Props = $props()

	let handleClick = () => {
		if (disabled) return
		if (onUpdate) onUpdate(!isEnabled)
	}

	function handleKeyPress(e: KeyboardEvent) {
		if (e.key === "Enter") {
			handleClick()
		}
	}
</script>

<div
	class="toggle-switch {disabled ? 'disabled' : ''}"
	tabindex="0"
	onclick={handleClick}
	onkeydown={handleKeyPress}
	use:tooltip={{ content: info, pointing: "top" }}
>
	<div class="toggle-switch-indicator-container {isEnabled ? 'active' : ''}">
		<div class="toggle-switch-indicator"></div>
	</div>
</div>

<style>
	.toggle-switch {
		cursor: pointer;
		height: 1rem;
		width: 2rem;
		border: 1px solid var(--color-text);
		border-radius: 100vw;
		position: relative;
		overflow: hidden;
	}

	.toggle-switch.disabled {
		pointer-events: none;
		opacity: 0.5;
	}

	.toggle-switch.disabled .toggle-switch-indicator {
		background-color: var(--color-text);
	}

	.toggle-switch-indicator {
		background-color: var(--color-text-light);
		width: 0.75rem;
		height: 0.75rem;
		border-radius: 100vw;
		margin-top: auto;
		margin-bottom: auto;
	}

	.toggle-switch-indicator-container {
		position: absolute;
		width: 100%;
		height: 100%;
		left: calc(-100% + 0.75rem);
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: flex-end;
		transition:
			left 250ms ease-in-out,
			background-color 250ms ease-in-out;
	}

	.toggle-switch-indicator-container.active {
		background-color: var(--color-main);
		left: 0;
	}
</style>
